export { default } from './AlternativeProductsTableItem'
